import React from 'react';
import { WarningTwoTone } from '@ant-design/icons';
import ls from './FormEditor.less';

export class DesignErrorScope extends React.Component {

  state = {hasError: false};

  render() {
    if (this.state.hasError) {
      return (
        <div className={ls.misconfigured}>
          <WarningTwoTone twoToneColor="#EBAF4C" /> component misconfigured
        </div>
      );
    }
    return this.props.children;
  }

  componentDidCatch(error) {
    this.setState({hasError: true});
    console.error(error);
  }
}


